const isValidTerm = (term) =>
  term && typeof term === 'string' && term.length > 2;

export default isValidTerm;
